export const getIntervalLabel = (isMonthly) => (isMonthly ? "aylık" : "tek sefer");
export const getPrice = (p) => Number(p?.Price ?? p?.Amount ?? p?.UnitPrice ?? 0);
export const formatEUR = (n) =>
    new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 2,
    }).format(Number.isFinite(n) ? n : 0);
